module.exports = [{"value":null,"text":"= Please Select Languages =","disabled":true,"selected":true},{"value":"English","text":"English"},{"value":"Tamil","text":"Tamil"},{"value":"Mandarin","text":"Mandarin"},{"value":"Bangladesh","text":"Bangladesh"}]


//////////////////
// WEBPACK FOOTER
// ./static/languages.json
// module id = ./static/languages.json
// module chunks = 0 2 3 6